/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForTagPostureSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForTagPostureSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForTagPostureSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForTagPostureSync>): BackgroundJobPayloadForTagPostureSync {
        let obj = Object.assign(new BackgroundJobPayloadForTagPostureSync(), model);
        BackgroundJobPayloadForTagPostureSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForTagPostureSync>): BackgroundJobPayloadForTagPostureSync {
        if (!model) return null;
        return BackgroundJobPayloadForTagPostureSync.newInstance(<BackgroundJobPayloadForTagPostureSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForTagPostureSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForTagPostureSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForTagPostureSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForTagPostureSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
